import React, { useState } from 'react'
import { AnimatePresence } from 'framer-motion'
import { Badge, Button } from 'antd'
import { SearchOutlined } from '@ant-design/icons'

import ModalSearch from 'components/Modal/ModalSearch'
import Pagination from 'components/Pagination'

import { useVaultContext } from './VaultContext'

function TableListHeader() {
  const { loading, currentPage, totalPage, search, dispatch } =
    useVaultContext()

  const [showSearch, setShowSearch] = useState(false)

  const handlePageChange = (newPage: number) => {
    dispatch({ type: 'SET_CURRENT_PAGE', payload: newPage })
  }

  const handleSearch = (value: string) => {
    if (value !== search) {
      dispatch({ type: 'SET_SEARCH', payload: value })
    }
  }

  return (
    <React.Fragment>
      <div
        className='table-list-header sticky'
        style={{ borderBottomWidth: 1 }}
      >
        <div className='left'>
          <Pagination
            disabled={loading}
            current={currentPage}
            total={totalPage}
            onPageChange={handlePageChange}
          />
        </div>
        <div className='right'>
          <Button
            disabled={loading}
            size='large'
            className='ant-btn-secondary'
            onClick={() => setShowSearch(true)}
          >
            <Badge dot={!!search}>
              <SearchOutlined />
            </Badge>
          </Button>
        </div>
      </div>
      <AnimatePresence>
        {showSearch && (
          <ModalSearch
            title='Search Records'
            placeholder='Search records'
            value={search}
            onSearch={handleSearch}
            onCancel={() => setShowSearch(false)}
          />
        )}
      </AnimatePresence>
    </React.Fragment>
  )
}

export default TableListHeader
